import { render } from "./DialogComponentOrario.vue?vue&type=template&id=7dc884c7"
import script from "./DialogComponentOrario.vue?vue&type=script&lang=js"
export * from "./DialogComponentOrario.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__